<script lang="ts" setup>
withDefaults(defineProps<{ url?: string, name?: string, variant?: 'default' | 'initials' }>(), {
  variant: 'default',
})
</script>

<template>
  <div class="w-11 h-11 rounded-full inline-flex items-center justify-center align-middle relative ui-avatar">
    <img
      v-if="url"
      alt=""
      class="h-full w-full rounded-full object-cover"
      :src="url"
    >

    <div
      v-else-if="!url && variant === 'default'"
      class=" bg-[#151515] text-white leading-1 flex h-full w-full items-center justify-center rounded-full "
    >
      <img
        alt=""
        src="https://belong.net/images/external/other/logo.svg" class="h-9 w-9 object-contain opacity-50"
      >
    </div>

    <div v-else-if="variant === 'initials'" class="bg-[#151515] text-white leading-1 flex h-full w-full items-center justify-center rounded-full ">
      <slot name="initials" />
    </div>

    <slot />
  </div>
</template>
